import index from "./footerBar.vue";
export default index;
